import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { initMetaPixel, trackPageView } from "../../utils/metaPixel";

/**
 * Initializes the Meta Pixel SDK on mount, then tracks page views
 * for client-side route transitions.
 */
export default function MetaPixelAnalytics() {
  const location = useLocation();
  const hasMountedRef = useRef(false);

  // Load the pixel SDK once on first render
  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    trackPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
}
